import { render } from "./generateWx.vue?vue&type=template&id=5c29a04f&scoped=true"
import script from "./generateWx.vue?vue&type=script&lang=js"
export * from "./generateWx.vue?vue&type=script&lang=js"

import "./generateWx.vue?vue&type=style&index=0&id=5c29a04f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c29a04f"],['__file',"src/components/generateWx/generateWx.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c29a04f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c29a04f', __exports__)) {
    console.log('reload')
    api.reload('5c29a04f', __exports__)
  }
  
  module.hot.accept("./generateWx.vue?vue&type=template&id=5c29a04f&scoped=true", () => {
    console.log('re-render')
    api.rerender('5c29a04f', render)
  })

}


export default __exports__